import { TagSystem } from './Tag.System';

export const Tag = { System: TagSystem };
